<template>
  <Head title="El Aliado Técnico" />
  <div>
    <carousel-web />
    <div class="container mx-auto p-4">
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4"> 
        <a href="/web/products?search[category]=2" class="rounded-lg p-4">
          <img src="https://dummyimage.com/300x200/000/f2f2f2.png" alt="Repuestos de cocina" class="w-full h-auto rounded-lg">
        </a>
        <a href="/web/products?search[category]=3" class="rounded-lg p-4">
          <img src="https://dummyimage.com/300x200/000/f2f2f2.png" alt="Repuestos de licuadoras" class="w-full h-auto rounded-lg">
        </a>
        <a href="/web/products?search[category]=4" class="rounded-lg p-4">
          <img src="https://dummyimage.com/300x200/000/f2f2f2.png" alt="Repuestos de ferretería" class="w-full h-auto rounded-lg">
        </a>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <a href="/web/products?search[category]=5" class="rounded-lg p-4">
          <img src="https://dummyimage.com/500x300/000/f2f2f2.png" alt="Refrigeración" class="w-full h-auto rounded-lg">
        </a>
        <a href="/web/products?search[category]=6" class="rounded-lg p-4">
          <img src="https://dummyimage.com/500x300/000/f2f2f2.png" alt="Repuestos de lavadoras" class="w-full h-auto rounded-lg">
        </a>
      </div>
    </div>
    <div class="p-5 md:p-20">
      <h2 class="font-bold text-2xl text-center pb-10 uppercase">Productos destacados</h2>
      <product-list :products="products" :auth="auth" />
    </div>
    
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '../../Layouts/WebLayout.vue'
import CarouselWeb from './components/CarouselWeb.vue'
import ProductList from './components/ProductList.vue'
export default {
  components: { CarouselWeb, Head, ProductList },
  props: {
    auth: Object,
    products: Object
  },
  layout: WebLayout,
}
</script>
